<template>

  <div class="px-5 py-5">
    <notifications position="top center" ></notifications>

    <div v-show="!myDeposit.is_closed"  class="flex flex-wrap -mx-2">

      <deposit-name-link :deposit="this.deposit"/>

<!--      <div class="my-2 px-2 w-1/2 overflow-hidden" v-show="!myDeposit.is_closed">-->
      <close-deposit-button v-show="!myDeposit.is_closed"  :deposit="this.deposit"/>

    </div>

    <h2 v-show="myDeposit.is_closed"  class="font-bold text-center mb-1 text-3xl">Closed Deposit <i>(#{{myDeposit.id}})</i></h2>
    <h3 v-show="myDeposit.is_closed"  class="font-medium text-center text-lg text-pink"> {{deposit.name}}</h3>


      <div v-show="myDeposit.is_closed"  class="flex flex-col bg-white text-left text-sm text-gray justify-between items-center hover:bg-gray-100 border border-gray-200 xl:w-6/12 mx-auto my-5 border-b-0">
      <div class="flex flex-row w-full items-center border-b border-gray-200 bg-gray-100 items-stretch">
        <div class="flex items-center justify-center w-1/2 xl:w-1/3 px-3 py-3 text-center text-gray-500 font-medium">
          Bank Identifier
        </div>
        <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-auto px-6 py-3 bg-gray-25 text-gray-500 flex-1">
          {{deposit.bank_deposit_identifier}}
        </div>
      </div>
      <div class="flex flex-row w-full items-center border-b border-gray-200 bg-gray-100 items-stretch">
        <div class="flex items-center justify-center w-1/2 xl:w-1/3 px-3 py-3 text-center text-gray-500 font-medium">
          Deposit Closed On
        </div>
        <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-auto px-6 py-3 bg-gray-25 text-gray-500 flex-1">
          {{formmatedClosedDate}}
        </div>
      </div>
      <div class="flex flex-row w-full items-center border-b border-gray-200 bg-gray-100 items-stretch">
        <div class="flex items-center justify-center w-1/2 xl:w-1/3 px-3 py-3 text-center text-gray-500 font-medium">
          Notes
        </div>
        <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-auto px-6 py-3 bg-gray-25 text-gray-500 flex-1">
          {{deposit.notes}}
        </div>
      </div>
    </div>


    <span v-show="!myDeposit.is_closed">

    <div class="flex flex-wrap -mx-2">

      <campaign-search-input :classes="`sm:w-4/6 `" :show-only-top-level-campaigns="false" />


      <div class="my-2 px-2 w-full sm:w-2/6 flex inline space-x-5 justify-around">
        <div class="flex items-center">
          <input id="option_check" v-model="form.payment_type_id" value="2" type="radio" class="focus:ring-blue-200 h-4 w-4 text-blue border-gray-300">
          <label for="option_check" class="ml-3 block text-sm font-medium text-gray-700">
            Check
          </label>
        </div>
        <div class="flex items-center">
          <input id="option_cash" v-model="form.payment_type_id" value="3" type="radio" class="focus:ring-blue-200 h-4 w-4 text-blue border-gray-300">
          <label for="option_cash" class="ml-3 block text-sm font-medium text-gray-700">
            Cash
          </label>
        </div>
        <div class="flex items-center">
          <input id="option_ach" v-model="form.payment_type_id" value="4" type="radio" class="focus:ring-blue-200 h-4 w-4 text-blue border-gray-300">
          <label for="option_ach" class="ml-3 block text-sm font-medium text-gray-700">
            ACH
          </label>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap -mx-2 overflow-hidden">
      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <input type="text" v-model="form.check_number"  id="checkNumber" class="w-full block mx-auto sm:text-sm" placeholder="Check #">
      </div>

      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <div class="max-w-lg flex shadow-sm">
              <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                $
              </span>
          <input type="text" v-model="form.amount" id="amount" class="flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300" placeholder="Amount">
        </div>
      </div>

      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <input type="text" v-model="form.first_name"  id="firstName" class="w-full block mx-auto sm:text-sm" placeholder="First Name">
      </div>

      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <input type="text" v-model="form.last_name"  id="lastName" class="w-full block mx-auto sm:text-sm" placeholder="Last Name">
      </div>
    </div>

    <div class="flex flex-wrap -mx-2 overflow-hidden">
      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <input type="text" v-model="form.email"  id="emailAddress" class="w-full block mx-auto sm:text-sm" placeholder="Email">
      </div>

      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <input type="text" v-model="form.business_name" id="businessName" class="w-full block mx-auto sm:text-sm" placeholder="Business Name">
      </div>

      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <!--
          Google Places Autocomplete Integration

          This component provides address autocomplete functionality using Google Places API.
          When a user types an address and selects from the dropdown, it automatically fills
          the address, city, state, and ZIP fields via the @place-selected event.

          Props:
          - v-model: Binds to form.address for 2-way data binding
          - types: ['address'] restricts to street addresses (vs cities or establishments)
          - @place-selected: Triggers handleAddressSelected() with parsed address data

          See: resources/js/components/general/AddressAutocomplete.vue for component implementation
        -->
        <address-autocomplete
          v-model="form.address"
          input-id="addressOne"
          placeholder="Start typing an address..."
          :types="['address']"
          @place-selected="handleAddressSelected"
          class="w-full block mx-auto"
        />
      </div>

      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <input type="text" v-model="form.address2" id="addressTwo" class="w-full block mx-auto sm:text-sm" placeholder="Address Line Two">
      </div>
    </div>

    <div class="flex flex-wrap -mx-2 overflow-hidden">
      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <input type="text" v-model="form.city" id="city" class="w-full block mx-auto sm:text-sm" placeholder="City">
      </div>

<!--      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">-->
<!--        <input type="text"  v-model="form.state" id="state" class="w-full block mx-auto sm:text-sm" placeholder="State">-->
<!--      </div>-->

      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <select  v-model="form.state" class="w-full block mx-auto sm:text-sm">
          <option value="0">Select State</option>
          <option value="AL">Alabama</option>
          <option value="AK">Alaska</option>
          <option value="AZ">Arizona</option>
          <option value="AR">Arkansas</option>
          <option value="CA">California</option>
          <option value="CO">Colorado</option>
          <option value="CT">Connecticut</option>
          <option value="DE">Delaware</option>
          <option value="DC">District Of Columbia</option>
          <option value="FL">Florida</option>
          <option value="GA">Georgia</option>
          <option value="HI">Hawaii</option>
          <option value="ID">Idaho</option>
          <option value="IL">Illinois</option>
          <option value="IN">Indiana</option>
          <option value="IA">Iowa</option>
          <option value="KS">Kansas</option>
          <option value="KY">Kentucky</option>
          <option value="LA">Louisiana</option>
          <option value="ME">Maine</option>
          <option value="MD">Maryland</option>
          <option value="MA">Massachusetts</option>
          <option value="MI">Michigan</option>
          <option value="MN">Minnesota</option>
          <option value="MS">Mississippi</option>
          <option value="MO">Missouri</option>
          <option value="MT">Montana</option>
          <option value="NE">Nebraska</option>
          <option value="NV">Nevada</option>
          <option value="NH">New Hampshire</option>
          <option value="NJ">New Jersey</option>
          <option value="NM">New Mexico</option>
          <option value="NY">New York</option>
          <option value="NC">North Carolina</option>
          <option value="ND">North Dakota</option>
          <option value="OH">Ohio</option>
          <option value="OK">Oklahoma</option>
          <option value="OR">Oregon</option>
          <option value="PA">Pennsylvania</option>
          <option value="RI">Rhode Island</option>
          <option value="SC">South Carolina</option>
          <option value="SD">South Dakota</option>
          <option value="TN">Tennessee</option>
          <option value="TX">Texas</option>
          <option value="UT">Utah</option>
          <option value="VT">Vermont</option>
          <option value="VA">Virginia</option>
          <option value="WA">Washington</option>
          <option value="WV">West Virginia</option>
          <option value="WI">Wisconsin</option>
          <option value="WY">Wyoming</option>
        </select>
      </div>

      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <input type="text" v-model="form.zip"  id="zipCode" class="w-full block mx-auto sm:text-sm" placeholder="ZIP">
      </div>

      <div class="my-2 px-2 w-1/2 sm:w-1/4 overflow-hidden">
        <div class="relative flex items-start">
          <div class="flex items-center h-5">
            <input id="comments" name="comments" type="checkbox"  v-model="form.is_anonymous" class="focus:ring-0 h-4 w-4 text-pink border-gray-300 rounded">
          </div>
          <div class="ml-3 text-sm">
            <label for="comments" class="font-medium text-gray-700">Is Anonymous</label>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap -mx-2 overflow-hidden flex-row flex-row-reverse">
      <div class="my-2 px-2 w-full sm:w-1/2 overflow-hidden space-x-3">
        <input type="text" v-model="form.dedication" id="dedication" class="w-full block mx-auto sm:text-sm" placeholder="Dedication">
      </div>

      <div class="my-2 px-2 w-full sm:w-1/2 space-x-3">
        <button @click="saveDeposit" type="button" class="mx-auto inline text-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none focus:outline-none  focus:ring-green-200">Add New Item</button>

        <button @click="resetForm" type="button" class="mx-auto inline text-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-black bg-gray-100 hover:bg-gray-200 focus:outline-none focus:outline-none  focus:ring-gray-100">Reset</button>
      </div>
    </div>

    </span>

    <div class="mt-5">
      <h5 class="mb-5">Files</h5>

      <add-file-to-deposit-button v-show="!myDeposit.is_closed" :deposit="this.deposit"/>

      <div v-if="depositFiles && depositFiles.length > 0" class="xl:border border-gray-200">
        <div class="hidden xl:flex xl:flex-row px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray uppercase tracking-wider justify-between border-b border-gray-200">
          <div class="xl:w-4/12">File Name</div>
          <div class="xl:w-4/12">Date</div>
          <div class="xl:w-4/12">&nbsp;</div>
        </div>
        <div class="flex flex-col space-y-3 xl:space-y-0">
          <div v-for="depositFile in depositFiles" class="flex flex-col xl:flex-row xl:px-6 xl:py-3 bg-white text-left text-sm text-gray justify-between items-center hover:bg-gray-100 border border-gray-200 xl:border-b xl:border-gray-50 xl:border-l-0 xl:border-t-0 xl:border-r-0 xl:items-start">

            <div class="flex flex-row w-full items-center xl:w-4/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
              <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                File Name
              </div>
              <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left ">
                <a class="text-pink" :href="depositFile.file_path" target="_blank">{{depositFile.name}}</a>
              </div>
            </div>

            <div class="flex flex-row w-full items-center xl:w-4/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
              <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                Date
              </div>
              <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left whitespace-nowrap">
                {{  formattedDate(depositFile.created_at) }}
              </div>
            </div>

            <div class="flex flex-row w-full items-center xl:w-4/12 bg-gray-100 xl:bg-transparent justify-end xl:text-base">
              <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                Actions
              </div>
              <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-auto px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-center text-gray-500">
                <remove-deposit-file-crud-button :deposit-file="depositFile" :key="depositFile.id" @fileRemoved="fileRemoved"></remove-deposit-file-crud-button>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

    <!-- Projects table (small breakpoint and up) -->
    <div class="mt-8 ">

      <h5 class="font-medium text-center mb-3 text-base">{{depositedChecks.length}} Items in this Deposit - <span class="font-bold">${{totalCheckAmount}}</span></h5>
      <h6 class="font-medium text-center mb-3 text-base">{{paymentTypeSummaryText}}</h6>


      <div class="xl:border border-gray-200">
        <div class="hidden xl:flex xl:flex-row px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray uppercase tracking-wider justify-between border-b border-gray-200">
          <div class="xl:w-1/12">Campaign ID</div>
          <div class="xl:w-1/12">Amount</div>
          <div class="xl:w-2/12">Name</div>
          <div class="xl:w-3/12">Business</div>
          <div class="xl:w-1/12">Check #</div>
          <div class="xl:w-1/12">Type</div>
          <div class="xl:w-2/12">Date</div>
          <div class="xl:w-1/12" v-show="!myDeposit.is_closed">&nbsp;</div>
        </div>
        <div class="flex flex-col space-y-3 xl:space-y-0">

          <div v-for="depositedCheck in depositedChecks" class="flex flex-col xl:flex-row xl:px-6 xl:py-3 bg-white text-left text-sm text-gray justify-between items-center hover:bg-gray-100 border border-gray-200 xl:border-b xl:border-gray-50 xl:border-l-0 xl:border-t-0 xl:border-r-0 xl:items-start">
            <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
              <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Campaign ID
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left whitespace-nowrap">
                  {{ depositedCheck.campaign_id }}
                </div>
              </div>
            <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
              <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Amount
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left whitespace-nowrap">
                  $  {{ depositedCheck.amount }}
                </div>
              </div>
            <div class="flex flex-row w-full items-center xl:w-2/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
              <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Name
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
                  {{ depositedCheck.name ? depositedCheck.name :  '&nbsp' }}
                </div>
              </div>
            <div class="flex flex-row w-full items-center xl:w-3/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
              <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Business
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
                  {{ depositedCheck.business_name ? depositedCheck.business_name :  '&nbsp' }}
                </div>
              </div>
            <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
              <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Check #
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
                  {{ depositedCheck.check_number ? depositedCheck.check_number :  '&nbsp' }}
                </div>
              </div>
            <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
              <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Type
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:pl-1.5 text-lg xl:pt-1">
                  <i v-if="depositedCheck.donationPaymentType === `Check`" title="Check Donation" class="text-blue-500 fas fa-money-check"></i>
                  <i v-if="depositedCheck.donationPaymentType === `Cash`"  title="Cash Donation" class="text-green-500 fas fa-money-bill"></i>
                  <i v-if="depositedCheck.donationPaymentType === `ACH`"  title="ACH Transfer" class="text-gold-500 fas fa-university"></i>
                </div>
              </div>
            <div class="flex flex-row w-full items-center xl:w-2/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
              <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Date
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left whitespace-nowrap">
                  {{ depositedCheck.created }}
                </div>
              </div>
            <div v-show="!myDeposit.is_closed"  class="flex flex-row w-full items-center xl:w-1/12 bg-gray-100 xl:bg-transparent justify-end xl:text-base items-stretch">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Actions
                </div>
              <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-auto px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-center text-gray-500">
                 <deposit-view-page-crud-button  :deposited-check="depositedCheck" :key="depositedCheck.id" @depositRemoved="depositRemoved"></deposit-view-page-crud-button>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

</template>


<script>
import moment from 'moment';
import CloseDepositButton from "./CloseDepositButton";
import DepositNameLink from "./DepositNameLink";
import AddFileToDepositButton from "./AddFileToDepositButton";
// Import Google Places Address Autocomplete component for automatic address population
import AddressAutocomplete from '../general/AddressAutocomplete.vue';

export default {
  props: {
    depositId: null,
    myDeposit: {},
  },
  components: {
    AddressAutocomplete,
    AddFileToDepositButton,
    DepositNameLink,
    CloseDepositButton
  },
  data() {
    return {
      form: {
        campaign_id: null,
        amount: null,
        check_number: null,
        payment_type_id: 2,
        first_name: null,
        last_name: null,
        business_name: null,
        email: null,
        address: null,
        address2: null,
        city: null,
        state: 0,
        zip: null,
        dedication: null,
        is_anonymous: 0,
        deposit_id: this.depositId,
        check_deposit_id: null,
        notes: null,
        name: null,
      },
      editForm: {
        campaign_id: null,
        amount: null,
        check_number: null,
        payment_type_id: 2,
        first_name: null,
        last_name: null,
        business_name: null,
        email: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        dedication: null,
        is_anonymous: 0,
        deposit_id: this.depositId,
        check_deposit_id: null,
      },
      deposit:{},
      check_deposits:[],
      selectedCampaign:'',
      paymentOptions: [
        { text: 'Check', value: '2' },
        { text: 'Cash', value: '3' },
        { text: 'ACH', value: '4' },
      ],
      saveText : 'Add New Item',
      updateText : 'Update Deposit',
      isSaving : false,
      isUpdating : false,
      bank_deposit_identifier : null,
      deposit_notes : null,
      depositToEdit : null,
      files : null,
      isOpen : false,
    }
  },
  created() {
    if (this.depositId) {
      this.getDeposits()
    }

    this.emitter.on('search-selected-campaign', selectedCampaignFromSearch => {
      this.selectedCampaign = selectedCampaignFromSearch
      if (this.selectedCampaign){//do a check here, on edit, this variable is reset to null
        //but we dont want value of campaign id to change
        this.form.campaign_id = selectedCampaignFromSearch.id
        this.editForm.campaign_id = selectedCampaignFromSearch.id
      }
    });

    this.emitter.on('check-deposit-updated', () => {
      this.getDeposits()
    });
  },
  computed: {
    depositedChecks() {
      return this.check_deposits
    },
    totalCheckAmount() {
      return Number(_.sumBy(this.depositedChecks, item => Number(item.amount))).toFixed(2);
    },
    saveTextCurrent() {
      return this.saveText
    },
    updateTextCurrent() {
      return this.updateText
    },
    formmatedClosedDate() {
      return moment(this.deposit.closed_date).format('MM-DD-YYYY')
    },
    token() {
      return $('meta[name="csrf-token"]').attr('content')
    },
    getFilePostUrl() {
      return '/admin/deposit-file/'+this.depositId
    },
    depositFiles() {
      return this.files
    },
    paymentTypeSummaryText() {
      let summaryText = '';
      let groupDeposits = _.groupBy(this.check_deposits, 'donationPaymentType');

      _.forEach(groupDeposits, (deposits, paymentType) => {
        summaryText = summaryText + '(' + deposits.length + ') '+ paymentType
            + ' $' + Number(_.sumBy(deposits, item => Number(item.amount))).toFixed(2) + ' | ';
      });

      summaryText = summaryText.slice(0, -1);//remove last |
      summaryText = summaryText.substring(0, summaryText.length - 1);//remove last |
      return summaryText
    }
  },
  methods: {
    /**
     * Handle address selection from Google Places Autocomplete
     *
     * This method is called when a user selects an address from the AddressAutocomplete component.
     * It automatically populates the address, city, state, and ZIP fields based on the selected place.
     *
     * @param {Object} data - The place data emitted by AddressAutocomplete component
     * @param {Object} data.components - Parsed address components (city, state, zip, streetAddress)
     * @param {Object} data.place - Raw Google Places API place object
     * @param {string} data.formatted_address - Full formatted address from Google
     *
     * Field Mapping:
     * - components.streetAddress -> form.address (e.g., "123 Main St")
     * - components.city -> form.city (e.g., "Coral Springs")
     * - components.state -> form.state (e.g., "FL" - 2-letter state code)
     * - components.zip -> form.zip (e.g., "33065")
     */
    handleAddressSelected(data) {
      if (data && data.components) {
        // Use streetAddress from parsed components (includes street number + street name)
        this.form.address = data.components.streetAddress || '';
        this.form.city = data.components.city || '';
        this.form.state = data.components.state || 0;
        this.form.zip = data.components.zip || '';

        // Note: address2 field is left empty for user to manually add apartment/unit numbers
      }
    },
    setOpenToFalse() {
      this.isOpen = false;
    },
    formattedDate(date) {
      return moment(date).format('MM-DD-YYYY')
    },
    getDeposits(){
      axios.get('/get-deposit/' + this.depositId)
          .then(response => {
            // console.log(response.data)
            this.deposit = response.data.deposit
            this.deposit_notes = response.data.deposit.notes
            this.check_deposits = response.data.checkDeposits
            this.files = response.data.deposit.deposit_files
          })
    },
    saveDeposit() {
      if (!this.form.campaign_id) {
        this.$notify({
          text: 'Campaign is required',
          type: 'error',
        })
        return
      }
      if (!this.form.first_name && !this.form.last_name && !this.form.business_name) {
        this.$notify({
          text: 'Either first name or last name or business name is required',
          type: 'error',
        })
        return
      }
      if (!this.form.amount) {
        this.$notify({
          text: 'Amount is required',
          type: 'error',
        })
        return
      }

      this.isSaving = true;
      this.saveText = 'Adding New Item...'

      axios.post('/create-check-deposit', this.form)
          .then(response => {
            this.$notify({text: 'New item added',type: 'success', })
            this.check_deposits = response.data
            this.resetForm()
          })
    },
    resetForm() {
      this.form.first_name = null;
      this.form.last_name = null;
      this.form.amount = null;
      this.form.check_number = null;
      this.form.business_name = null;
      this.form.email = null;
      this.form.address = null;
      this.form.address2 = null;
      this.form.city = null;
      this.form.state = null;
      this.form.zip = null;
      this.form.dedication = null;
      this.form.is_anonymous = 0;
      this.form.payment_type_id = 2;
      //this.form.campaign_id = null;
      this.form.check_deposit_id = null;
      this.saveText = 'Add New Item';
      this.isUpdating = false
      this.isSaving = false
      this.emitter.emit('search-selected-campaign-placeholder', "Type any 4 letters in a campaign name...")
    },
    depositRemoved(data) {
      this.check_deposits = data.check_deposits;
    },
    fileRemoved(data) {
      this.check_deposits = data.check_deposits;
      this.files = data.files
    },
    handleAddressSelected(data) {
      // Google Places API returns structured address components
      const { components, formatted_address } = data;

      // Auto-fill city, state, and zip from Google Places data
      if (components.city) {
        this.form.city = components.city;
      }

      if (components.state) {
        this.form.state = components.state;
      }

      if (components.zip) {
        this.form.zip = components.zip;
      }

      // Use the street address component if available, otherwise use formatted address
      if (components.streetAddress) {
        this.form.address = components.streetAddress;
      } else if (formatted_address) {
        // Extract just the street address from the formatted address
        const addressParts = formatted_address.split(',');
        if (addressParts.length > 0) {
          this.form.address = addressParts[0].trim();
        }
      }

      // Log for debugging (optional - remove in production)
      console.log('Google Places data:', { components, formatted_address });
      console.log('Updated form:', {
        address: this.form.address,
        city: this.form.city,
        state: this.form.state,
        zip: this.form.zip
      });
    }
  }
}
</script>
